// extracted by mini-css-extract-plugin
module.exports = {"largeTablePage":"LargeTablePage_largeTablePage___5Wmu"};